// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  width: 100%;
  height: calc(100vh - 0.4rem);
  overflow: hidden;
  display: flex;
  background-color: #fff;
}
.home-container {
  width: 75%;
  height: 100%;
}
.home-container-default {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.home-container .container-data {
  width: 100%;
  height: calc(100% - 0.25rem);
  margin-top: 0.125rem;
  display: flex;
}
.home-container .container-data-code {
  width: calc(80% - 0.125rem);
  height: 100%;
  background: #fdfbf9;
  padding: 0.125rem;
  border-radius: 0.0625rem;
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(12, 12, 13, 0.1019607843);
  position: relative;
  margin: 0 0.0625rem 0 0.0625rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-container .container-data-code-main {
  display: none;
}
.home-container .container-data-code-main-show {
  display: block;
}
.home-container .container-data-code-full {
  width: 95%;
  margin-right: 0.0625rem;
}
.home-container .container-data .progress-loading {
  width: 60% !important;
}
.home-container .container-data .progress-loading .anticon-double-left {
  display: none;
}
.home-container .container-data .loading {
  width: 0.9375rem;
  display: block;
}
.home-container .container-data .loading-hide {
  display: none;
}
.home-container .container-data-code-loading {
  width: 40%;
}
.home-container-full {
  animation: containerFull 300ms forwards;
}
@keyframes containerFull {
  0% {
    width: 75%;
  }
  100% {
    width: 100%;
  }
}
.home-chatbot {
  width: 25%;
  height: 100%;
  display: none;
}
.home-chatbot-main {
  width: calc(100% - 0.3125rem);
  height: calc(100% - 0.25rem);
  background: #f4f7f6;
  border: 0.00625rem solid rgba(152, 182, 177, 0.3);
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(12, 12, 13, 0.1019607843);
  border-radius: 0.125rem;
  margin-top: 0.125rem;
  position: relative;
  padding: 0.0625rem;
}
.home-chatbot-main .text-editor {
  position: absolute;
  bottom: 0.15rem;
  width: calc(100% - 0.125rem);
}
.home-chatbot-tips {
  font-size: 0.075rem;
  line-height: 0.1625rem;
  color: #8c8c8c;
}
.home-chatbot-tips .high-color {
  color: var(--var-prismer-chatbot);
  font-weight: bold;
  margin: 0 0.0125rem;
}
.home-chatbot-tips .font-weight {
  font-weight: bold;
}
.home-chatbot-tips ul {
  margin: 0.0625rem;
}
.home-chatbot-tips ul p {
  margin-left: 0.0625rem;
  font-size: 0.0625rem;
  line-height: 0.1rem;
}
.home-chatbot-full {
  animation: botFull 300ms forwards;
  display: block;
}
@keyframes botFull {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
.home-logo {
  max-width: 1.25rem;
}
.home-title {
  font-size: 0.1625rem;
  color: var(--var-prismer-color3);
  margin-top: 0.25rem;
}
.home .float-btn {
  background-color: var(--var-prismer-chatbot);
}
.home .float-btn svg {
  fill: #fff;
}
.home .ant-float-btn-default .ant-float-btn-body {
  background: none;
}
.home .ant-float-btn {
  width: 0.21875rem;
  height: 0.21875rem;
  right: 0.0625rem;
  bottom: 0.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home .ant-float-btn .ant-float-btn-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.home .ant-float-btn .anticon {
  font-size: 0.1125rem;
}
.home .ant-float-btn:hover {
  transform: scale(1.1);
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(152, 182, 177, 0.6);
}
.home .loading {
  max-width: 1.25rem;
}
.home .ant-drawer-content-wrapper,
.home .ant-drawer-mask {
  border-radius: 0.05rem;
}
.home .node-code-box {
  border-radius: 0.05rem;
}
.home .node-code-box .ant-drawer-body {
  padding: 0;
  background-color: #1e1e1e;
}
.home .node-code-box .ant-drawer-body::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.home .node-code-box .ant-drawer-header {
  background-color: #1e1e1e;
  color: #fff;
  font-size: 0.0875rem;
}
.home .node-code-box .ant-drawer-header .anticon-close {
  color: #fff;
}
.home .ant-drawer-close {
  font-size: 0.1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAAE;EACE,UAAA;EACA,YAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAGN;AADI;EACE,WAAA;EACA,4BAAA;EACA,oBAAA;EACA,aAAA;AAGN;AAFM;EACE,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;EACA,+EAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIR;AAHQ;EACE,aAAA;AAKV;AAJU;EACE,cAAA;AAMZ;AAFM;EACE,UAAA;EACA,uBAAA;AAIR;AAFM;EACE,qBAAA;AAIR;AAHQ;EACE,aAAA;AAKV;AAFM;EACE,gBAAA;EACA,cAAA;AAIR;AAHQ;EACE,aAAA;AAKV;AADM;EACE,UAAA;AAGR;AACE;EACE,uCAAA;AACJ;AACE;EACE;IACE,UAAA;EACJ;EACE;IACE,WAAA;EACJ;AACF;AACE;EACE,UAAA;EACA,YAAA;EACA,aAAA;AACJ;AAAI;EACE,6BAAA;EACA,4BAAA;EACA,mBAAA;EACA,iDAAA;EACA,+EAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAEN;AADM;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;AAGR;AAAI;EACE,mBAAA;EACA,sBAAA;EACA,cAAA;AAEN;AADM;EACE,iCAAA;EACA,iBAAA;EACA,mBAAA;AAGR;AADM;EACE,iBAAA;AAGR;AADM;EACE,iBAAA;AAGR;AAFQ;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;AAIV;AACE;EACE,iCAAA;EACA,cAAA;AACJ;AACE;EACE;IACE,2BAAA;EACJ;EACE;IACE,wBAAA;EACJ;AACF;AACE;EACE,kBAAA;AACJ;AACE;EACE,oBAAA;EACA,gCAAA;EACA,mBAAA;AACJ;AACE;EACE,4CAAA;AACJ;AAAI;EACE,UAAA;AAEN;AACE;EACE,gBAAA;AACJ;AACE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAAI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEN;AAAI;EACE,oBAAA;AAEN;AAAI;EACE,qBAAA;EACA,yEAAA;AAEN;AACE;EACE,kBAAA;AACJ;AACE;;EAEE,sBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AAAI;EACE,UAAA;EACA,yBAAA;AAEN;AADM;EACE,QAAA;EACA,SAAA;AAGR;AAAI;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;AAEN;AADM;EACE,WAAA;AAGR;AACE;EACE,iBAAA;AACJ","sourcesContent":[".home {\n  width: 100%;\n  height: calc(100vh - 64px);\n  overflow: hidden;\n  display: flex;\n  background-color: #fff;\n  &-container {\n    width: 75%;\n    height: 100%;\n    &-default {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n    }\n    .container-data {\n      width: 100%;\n      height: calc(100% - 40px);\n      margin-top: 20px;\n      display: flex;\n      &-code {\n        width: calc(80% - 20px);\n        height: 100%;\n        background: #fdfbf9;\n        padding: 20px;\n        border-radius: 10px;\n        box-shadow: 2px 4px 8px 2px #0c0c0d1a;\n        position: relative;\n        margin: 0 10px 0 10px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        &-main {\n          display: none;\n          &-show {\n            display: block;\n          }\n        }\n      }\n      &-code-full {\n        width: 95%;\n        margin-right: 10px;\n      }\n      .progress-loading {\n        width: 60% !important;\n        .anticon-double-left {\n          display: none;\n        }\n      }\n      .loading {\n        width: 150px;\n        display: block;\n        &-hide {\n          display: none;\n        }\n      }\n\n      &-code-loading {\n        width: 40%;\n      }\n    }\n  }\n  &-container-full {\n    animation: containerFull 300ms forwards;\n  }\n  @keyframes containerFull {\n    0% {\n      width: 75%;\n    }\n    100% {\n      width: 100%;\n    }\n  }\n  &-chatbot {\n    width: 25%;\n    height: 100%;\n    display: none;\n    &-main {\n      width: calc(100% - 50px);\n      height: calc(100% - 40px);\n      background: #f4f7f6;\n      border: 1px solid rgba(152, 182, 177, 0.3);\n      box-shadow: 2px 4px 8px 2px #0c0c0d1a;\n      border-radius: 20px;\n      margin-top: 20px;\n      position: relative;\n      padding: 10px;\n      .text-editor {\n        position: absolute;\n        bottom: 24px;\n        width: calc(100% - 20px);\n      }\n    }\n    &-tips {\n      font-size: 12px;\n      line-height: 26px;\n      color: #8c8c8c;\n      .high-color {\n        color: var(--var-prismer-chatbot);\n        font-weight: bold;\n        margin: 0 2px;\n      }\n      .font-weight {\n        font-weight: bold;\n      }\n      ul {\n        margin: 10px;\n        p {\n          margin-left: 10px;\n          font-size: 10px;\n          line-height: 16px;\n        }\n      }\n    }\n  }\n  &-chatbot-full {\n    animation: botFull 300ms forwards;\n    display: block;\n  }\n  @keyframes botFull {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  &-logo {\n    max-width: 200px;\n  }\n  &-title {\n    font-size: 26px;\n    color: var(--var-prismer-color3);\n    margin-top: 40px;\n  }\n  .float-btn {\n    background-color: var(--var-prismer-chatbot);\n    svg {\n      fill: #fff;\n    }\n  }\n  .ant-float-btn-default .ant-float-btn-body {\n    background: none;\n  }\n  .ant-float-btn {\n    width: 35px;\n    height: 35px;\n    right: 10px;\n    bottom: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .ant-float-btn-icon {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .anticon {\n      font-size: 18px;\n    }\n    &:hover {\n      transform: scale(1.1);\n      box-shadow: 2px 4px 8px 2px rgba(152, 182, 177, 0.6);\n    }\n  }\n  .loading {\n    max-width: 200px;\n  }\n  .ant-drawer-content-wrapper,\n  .ant-drawer-mask {\n    border-radius: 8px;\n  }\n  .node-code-box {\n    border-radius: 8px;\n    .ant-drawer-body {\n      padding: 0;\n      background-color: #1e1e1e;\n      &::-webkit-scrollbar {\n        width: 0px;\n        height: 0px;\n      }\n    }\n    .ant-drawer-header {\n      background-color: #1e1e1e;\n      color: #fff;\n      font-size: 14px;\n      .anticon-close {\n        color: #fff;\n      }\n    }\n  }\n  .ant-drawer-close {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
